export const LOGIN_SET_RESET_PASSWORD_STEP = 'LOGIN_SET_RESET_PASSWORD_STEP';
export const LOGIN_SET_RESET_PASSWORD_SUCCESS =
  'LOGIN_SET_RESET_PASSWORD_SUCCESS';
export const LOGIN_RESET_PASSWORD_LOADING = 'LOGIN_RESET_PASSWORD_LOADING';
export const LOGIN_SET_RESET_PASSWORD_CLEAR_ERROR =
  'LOGIN_SET_RESET_PASSWORD_CLEAR_ERROR';
export const LOGIN_RESET_PASSWORD_POST_ERROR =
  'LOGIN_RESET_PASSWORD_POST_ERROR';



// WEBPACK FOOTER //
// ./src/pages/login/state/resetpassword/types.js